import { Utils } from '../../../../../utils/common'
import { logger } from '../../../../../utils/common/logger'
import { DOMUtils } from '../../../../../utils/dom'
import { Store } from '../../../../../utils/storage/keys'
import { IdentityEvent } from '../../../../common/events/identity'
import { LoginService } from '../services/login-service'
import { IdentityScreen, LoginRadiusWidget, LRWidgetType } from './base'

export interface IWindow extends Window {
    tp: any
}

declare let window: IWindow

export class RegistrationWidget extends LoginRadiusWidget {

    constructor(container: string, lrObject: any) {
        super()
        this.widgetType = LRWidgetType.REGISTRATION
        this.lrObject = lrObject
        this.container = container
        const resendEmailButton = document.querySelector('.identity__link[type=button]') as HTMLButtonElement
        if (resendEmailButton) {
            resendEmailButton.addEventListener('click', () => {this.resendRegistrationEmail()})
        }
    }

    /**
     * Callback function used by LR widget
     * @param response any
     *
     * reference: https://www.loginradius.com/docs/libraries/js-libraries/js-form-library/
     */
    public onSuccess(response: any) {
        logger('debug', 'Registration form success', response)
        LoginService.clearErrors()
        const jwtToken = response.jwttoken
        // store token
        localStorage.setItem(Store.JWT, jwtToken)

        // Setting the new JWT token for authenticated user
        window.tp.push(['setExternalJWT', jwtToken])

        const profileData = LoginService.createProfile(response.Profile)
        const emailAddressEl = document.querySelector('[data-identity-email]')

        document.dispatchEvent(new CustomEvent(IdentityEvent.NEW_REGISTRATION, {
            detail: {
                email: profileData.email,
                uuid: profileData.uuid
            }
        }))

        // Update profile
        document.dispatchEvent(Utils.event(IdentityEvent.IDENTITY_CHANGE, {...profileData}))

        // Success page
        DOMUtils.removeClass(document.body, IdentityScreen.FORM)
        DOMUtils.addClass(document.body, IdentityScreen.SUCCESS)

        // add email address
        if (emailAddressEl) {
            emailAddressEl.innerHTML = profileData.email
        }

        LoginService.setRedirectLink(response.access_token)
        LoginService.setSSOFooterLinks(response.access_token)
    }

    /**
     * Callback function used by LR widget
     * @param errors any
     *
     * reference: https://www.loginradius.com/docs/libraries/js-libraries/js-form-library/
     */
    public onError(errors: any) {
        logger('error', errors)
        LoginService.clearErrors()
        LoginService.showErrors(errors)
    }

    /**
     * Resend email as per user request
     */
    public resendRegistrationEmail() {
        logger('info', 'Email resend requested')
        const registrantEmail = document.querySelector('[data-identity-email]')
        this.lrObject.api.resendEmailVerification({
                email: registrantEmail.innerHTML
            },
            this.onResendEmailSuccess,
            this.onResendEmailError
        )
    }

    /**
     * Callback function used by Resend email function
     * @param response any
     *
     * reference:
     * https://www.loginradius.com/docs/developer/references/javascript-library/form-library/#resend-email-verification
     */
    public onResendEmailSuccess(response: any) {
        logger('info', response)

        // Disable resent email button
        const resendEmailButton = document.querySelector('.identity__link[type=button]') as HTMLButtonElement
        resendEmailButton.setAttribute('disabled', 'disabled')

        // Show success message
        const successMessage = document.createElement('p')
        successMessage.innerHTML = 'We have resent your activation email'
        DOMUtils.addClass(successMessage, 'resend-activation-email__message--success')

        if (resendEmailButton) {
            resendEmailButton.parentElement.after(successMessage)
        }
    }

    /**
     * Callback function used by Resend email function
     * @param errors any
     *
     * reference:
     * https://www.loginradius.com/docs/developer/references/javascript-library/form-library/#resend-email-verification
     */
    public onResendEmailError(errors: any) {
        logger('error', errors)
    }
}
